import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.mandanten-constants';
import * as api from '../../../clients/api';

@Injectable()
export class ApiMandantenConstantsEffects {

    MandantenConstants$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_MANDANTEN_CONSTANTS),
        mergeMap((x: ac.GetMandantenConstantsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getMandantenConstants().pipe(
                map((result: any) => {
                    return new ac.GetMandantenConstantsErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetMandantenConstantsFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MandantenTemplatesService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MandantenTemplatesService {
        if (this.service === null) {
            this.service = this.injector.get(api.MandantenTemplatesService);
        }
        return this.service;
    }
}
